/* auto-generated on Fri, 07 Jun 2019 21:43:31 GMT */

export default {
  "@ux/accordion": "13.0.2",
  "@ux/alert": "10.0.0",
  "@ux/button": "17.1.0",
  "@ux/button-set": "10.0.0",
  "@ux/checkbox": "11.0.1",
  "@ux/checkbox-group": "11.0.0",
  "@ux/code": "5.0.0",
  "@ux/collapsible": "11.0.0",
  "@ux/component": "8.0.1",
  "@ux/containers": "4.0.0",
  "@ux/criteria": "10.1.1",
  "@ux/dropdown": "14.1.2",
  "@ux/fieldset": "5.1.0",
  "@ux/form": "12.0.0",
  "@ux/form-element": "15.1.5",
  "@ux/form-group": "6.0.2",
  "@ux/growl": "6.0.1",
  "@ux/icon": "10.0.2",
  "@ux/inline-styles": "11.0.1",
  "@ux/message-overlay": "9.0.0",
  "@ux/modal": "11.1.1",
  "@ux/namespace-component": "6.0.0",
  "@ux/pagination": "6.0.1",
  "@ux/palette-api-client": "3.1.0",
  "@ux/palettes": "5.3.1",
  "@ux/password": "11.0.1",
  "@ux/pivot": "6.0.3",
  "@ux/progress-bar": "8.0.1",
  "@ux/progress-steps": "7.0.0",
  "@ux/quantity-selector": "8.1.0",
  "@ux/radio": "11.0.0",
  "@ux/radio-group": "11.0.1",
  "@ux/react-native-device-fonts": "3.0.1",
  "@ux/remaining": "6.0.1",
  "@ux/scss-common": "7.2.3",
  "@ux/scss-definitions": "7.3.1",
  "@ux/search": "7.2.0",
  "@ux/spinner": "7.0.1",
  "@ux/stars": "6.0.0",
  "@ux/table": "6.1.0",
  "@ux/tabs": "12.0.3",
  "@ux/telephone-input": "7.0.0",
  "@ux/toggle": "10.0.0",
  "@ux/tooltip": "10.2.0",
  "@ux/transition": "4.0.0",
  "@ux/util": "4.1.0",
  "@ux/webpack-config": "10.1.3",
  "@ux/uxcore2": "11.3.1"
};